import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteV2SwitchTemplatesQueryVariables = Types.Exact<{
  kind?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type WebsiteV2SwitchTemplatesQuery = {
  __typename?: 'Query';
  carbonWebsiteTemplates: Array<{ __typename?: 'CarbonWebsiteTemplate'; id: string; s3Folder: string; published: boolean }>;
};

export type WebsiteV2CreateSiteWithV1DesignMutationVariables = Types.Exact<{
  input: Types.CarbonWeddingWebsiteGenerateFromEventInput;
}>;

export type WebsiteV2CreateSiteWithV1DesignMutation = {
  __typename?: 'Mutation';
  carbonWeddingWebsiteGenerateFromEvent: { __typename?: 'CarbonWeddingWebsiteGenerateResult'; runId: string; site: { __typename?: 'CarbonWeddingWebsiteSite'; id: string } };
};

export const WebsiteV2SwitchTemplatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2SwitchTemplates' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteTemplates' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'kind' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 's3Folder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2SwitchTemplatesQuery__
 *
 * To run a query within a React component, call `useWebsiteV2SwitchTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2SwitchTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2SwitchTemplatesQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useWebsiteV2SwitchTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>(WebsiteV2SwitchTemplatesDocument, baseOptions);
}
export function useWebsiteV2SwitchTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>(WebsiteV2SwitchTemplatesDocument, baseOptions);
}
export type WebsiteV2SwitchTemplatesQueryHookResult = ReturnType<typeof useWebsiteV2SwitchTemplatesQuery>;
export type WebsiteV2SwitchTemplatesLazyQueryHookResult = ReturnType<typeof useWebsiteV2SwitchTemplatesLazyQuery>;
export type WebsiteV2SwitchTemplatesQueryResult = Apollo.QueryResult<WebsiteV2SwitchTemplatesQuery, WebsiteV2SwitchTemplatesQueryVariables>;
export const WebsiteV2CreateSiteWithV1DesignDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2CreateSiteWithV1Design' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarbonWeddingWebsiteGenerateFromEventInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWeddingWebsiteGenerateFromEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'runId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'site' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2CreateSiteWithV1DesignMutationFn = Apollo.MutationFunction<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>;

/**
 * __useWebsiteV2CreateSiteWithV1DesignMutation__
 *
 * To run a mutation, you first call `useWebsiteV2CreateSiteWithV1DesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2CreateSiteWithV1DesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2CreateSiteWithV1DesignMutation, { data, loading, error }] = useWebsiteV2CreateSiteWithV1DesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebsiteV2CreateSiteWithV1DesignMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>(
    WebsiteV2CreateSiteWithV1DesignDocument,
    baseOptions,
  );
}
export type WebsiteV2CreateSiteWithV1DesignMutationHookResult = ReturnType<typeof useWebsiteV2CreateSiteWithV1DesignMutation>;
export type WebsiteV2CreateSiteWithV1DesignMutationResult = Apollo.MutationResult<WebsiteV2CreateSiteWithV1DesignMutation>;
export type WebsiteV2CreateSiteWithV1DesignMutationOptions = Apollo.BaseMutationOptions<WebsiteV2CreateSiteWithV1DesignMutation, WebsiteV2CreateSiteWithV1DesignMutationVariables>;
